// extracted by mini-css-extract-plugin
export var productImage = "_zj-0";